import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import NewFromTemplateIcon from '@material-ui/icons/FileCopyOutlined';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import * as CardActions from '../../redux/actions/card.actions';
import { BLUE, COMMUNICATION_EMAIL_STATUSES_PARAMETERS, COMMUNICATION_STATUSES_PARAMETERS, COMMUNICATION_STATUSES, TABLE_HEADER_COLOR } from '../../_config/consts';
import { getColorFromThemeName } from '../../_config/utils';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';
import { SmartphoneOutlined } from '@material-ui/icons';
import ReservationEmailIconCustom from '../CustomIcons/ReservationEmailIconCustom.jsx';
import { Divider } from 'antd';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  guestTag: {
    padding: 3,
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    minHeight: 80,
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  guestRowContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowWithAction: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowActionButton: {
    width: 40,
    height: 40,
  },
  rowActionButtonIcon: {
    fontSize: 20,
    color: '#E53935',
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  button: {
    color: 'red',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -8,
    marginTop: 5,
    marginBottom: 5,
    width: 'max-content',
  },
  buttonPositive: {
    color: BLUE,
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -8,
    marginTop: 5,
    marginBottom: 5,
    width: 'max-content',
  },
});

@connect((state) => ({ viewLoading: state.utils.viewLoading, communications: state.communications, themeName: state.settings.items.theme.data.themeName }))
class CommunicationTableView extends React.Component {


  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(CardActions.setOperationalMode(false));
  }

  render() {
    const {
      classes,
      viewLoading,
      themeName,
      canCreateItem,
      onDeleteCommunication,
      onCreateCommunicationFromModel,
      onNewCommunication,
      communications: { selectedCommunication, data: { content: communicationsData, pagination: { number: currentPage, size, totalPages, totalElements } }},
      onSelectCommunication,
      onRefreshCommunications,
      onFetchCommunicationsOnPage,
    } = this.props;
    const headerColor = getColorFromThemeName(themeName);
    return (
      <div className="list-view details-section" style={{ top: 190, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(communicationsData) ?
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={3}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}><Entity entity="communications" /></h3>
                        <IconButton onClick={() => onRefreshCommunications()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="communicationsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchCommunicationsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="#3f3f3f"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchCommunicationsOnPage(page)}
                        />
                      )}
                    />
                    </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="communicationName" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="communicationDescription" /></h4></TableCell>
                    <TableCell />
                    <TableCell />
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="communicationStatus" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="actions" /></h4></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(communicationsData, (communication) => {
                    const appStatusVariables = communication && communication.status && COMMUNICATION_STATUSES_PARAMETERS[communication.status] ? COMMUNICATION_STATUSES_PARAMETERS[communication.status] : null;
                    const emailStatusVariables = communication && communication.emailStatus && COMMUNICATION_EMAIL_STATUSES_PARAMETERS[communication.emailStatus] ? COMMUNICATION_EMAIL_STATUSES_PARAMETERS[communication.emailStatus] : null;
                    const showAppSection = communication.showInApp
                    const showEmailSection = emailStatusVariables && !emailStatusVariables.hiddenInTable
                    const appNotVisibleYet = appStatusVariables && communication.status && communication.status===COMMUNICATION_STATUSES.NOT_YET_VISIBLE
                    return (
                      <TableRow
                        key={communication.id}
                        className={classes.row}
                        hover
                        classes={{
                          selected: classes.rowSelected,
                          hover: classes.rowHovered,
                        }}
                        onClick={event => onSelectCommunication(communication)}
                        selected={selectedCommunication && selectedCommunication.id === communication.id}
                      >
                        <TableCell>
                          <div className={classes.guestRowContainer} style={{ marginTop: 0, marginBottom: 15, marginTop: 15, minWidth: 200, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <h5 style={{ fontWeight: 'bold', lineHeight: '1.5', fontSize: 16 }}>{`${communication.name}`}</h5>
                          </div>
                        </TableCell>
                        <TableCell colSpan={3} style={{ maxWidth: 750 }}>
                          <div style={{ display: 'flex', alignItems: 'center', wordBreak: 'break-all' }}>
                            <h5 style={{ lineHeight: '1.5', fontSize: 14, marginTop: 10 }}>{_.truncate(communication.description, { length: 500 })}</h5>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div style={{ display: 'flex', flexDirection: 'column', paddingTop: 5, paddingBottom: 8 }}>
                            {showAppSection && 
                              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <SmartphoneOutlined style={{ fontSize: 22, marginTop: 0, marginRight: 6, color: '#3f3f3f' }} />
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  {appStatusVariables && appStatusVariables.string && appStatusVariables.color ? (
                                    <h5 style={{ fontSize: 15, color: appStatusVariables.color, fontWeight: 'bold', margin: 0, marginBottom: 4, marginRight: 5 }}>
                                      <Entity key={appStatusVariables.string} entity={appStatusVariables.string} />
                                    </h5>
                                  ) : null}
                                  {appNotVisibleYet ? (
                                    <h5 style={{ color: '#3f3f3f', margin: 0, marginRight: 5 }}>
                                      {`${moment(communication.fromDate).format('LLL')}`}
                                    </h5>
                                  ) : (
                                    <h5 style={{ color: '#3f3f3f', margin: 0, marginRight: 5 }}>
                                      {`${moment(communication.fromDate).format('DD MMMM YYYY')} - ${moment(communication.toDate).format('DD MMMM YYYY')}`}
                                    </h5>
                                  )}
                                </div>
                              </div>
                            }
                            {showEmailSection && showAppSection &&
                              <Divider style={{margin: 8, marginTop: 9, marginLeft: 28, backgroundColor: '#ddd', maxWidth: 300, minWidth: 'unset', height: 1}}/>
                            }
                            {showEmailSection && 
                              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <ReservationEmailIconCustom style={{ width: 22, marginTop: 0, marginRight: 6, color: '#3f3f3f' }} />
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                  {emailStatusVariables && emailStatusVariables.string && emailStatusVariables.color ? (
                                    <h5 style={{ fontSize: 15, color: emailStatusVariables.color, fontWeight: 'bold', margin: 0, marginBottom: 4, marginRight: 5 }}>
                                      <Entity key={emailStatusVariables.string} entity={emailStatusVariables.string} />
                                    </h5>
                                  ) : null}
                                  {communication.emailSentDate || communication.emailDate ? (
                                    <h5 style={{ color: '#3f3f3f', margin: 0, marginRight: 5 }}>
                                      {`${moment(communication.emailSentDate || communication.emailDate).format('LLL')}`}
                                    </h5>
                                  ) : null}
                                </div>
                              </div>
                            }
                          </div>
                        </TableCell>
                        <TableCell>
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                            {canCreateItem ? (
                              <Button
                                onClick={(event) => {
                                  event.stopPropagation();
                                  onCreateCommunicationFromModel(communication);
                                }}
                                className={classes.buttonPositive}
                              >
                                <Entity entity="copy" />
                                <NewFromTemplateIcon style={{ fontSize: 15, marginLeft: 5 }} />
                              </Button>
                            ) : null}
                            {canCreateItem ? (
                              <Button
                                onClick={(event) => {
                                  event.stopPropagation();
                                  onDeleteCommunication(communication.id);
                                }}
                                className={classes.button}
                              >
                                <Entity entity="delete" />
                                <DeleteIcon style={{ fontSize: 15, marginLeft: 5 }} />
                              </Button>
                            ) : null}
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="communicationsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchCommunicationsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="#3f3f3f"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchCommunicationsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
            : (
              <div>
                {!viewLoading ? (
                  <EmptyView
                    title="noCommunications"
                    onNewEntity={canCreateItem ? () => onNewCommunication() : null}
                    newEntityTitle="addCommunications"
                    subtitle="startCommunications"
                    iconName="icon-simple-line-icons-user-following"
                />) : <ListLoadingView />}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(CommunicationTableView);
